import api from "../../api";
import type {
  FavoritesApiResponse,
  FavoritesContentData,
} from "../../../@types/portalAluno";
import { mapFavoritesResponse } from "../../../utils/portalAluno/mappers/favoritesMapper";

export const getFavoriteContents = async (): Promise<FavoritesContentData> => {
  const response = await api.get<FavoritesApiResponse>("mobile/favoritos");

  return mapFavoritesResponse(response.data);
};
